<template>
  <div :class="classes">
    <img :class="$style.main" :src="imageSrc" alt="" />

    <span v-if="borderColor" :class="$style.border" :style="borderStyles" />
    <img v-if="stickerSrc" :class="$style.sticker" :src="stickerSrc" alt="" />
  </div>
</template>

<script lang="ts" setup>
import { useCssModule, computed } from 'vue'
import { useConfig } from '@/ui-core/composables/use-config'
import type { Size } from './consts'

defineOptions({
  name: 'UiAvatar'
})

const props = withDefaults(
  defineProps<{
    src?: string
    borderColor?: string
    stickerSrc?: string
    size?: Size
  }>(),
  {
    src: undefined,
    borderColor: undefined,
    stickerSrc: undefined,
    size: 'default'
  }
)

const cssModule = useCssModule()

const { config } = useConfig()

const imageSrc = computed(() => props.src || config.value.avatarDefaultSrc)

const classes = computed(() => [
  cssModule.avatar,
  cssModule['size-' + props.size]
])

const borderStyles = computed(() => ({
  background: props.borderColor + ' border-box'
}))
</script>

<style lang="scss" module>
@use 'size';

.avatar {
  border-radius: var-default(--avatar-border-radius);
  width: var-default(--avatar-height);
  height: var-default(--avatar-height);
  position: relative;

  /* Size */
  @include size.add(xxs);
  @include size.add(xs);
  @include size.add(s);
  @include size.add(l);
  @include size.add(xl);
  @include size.add(xxl);
}

.main {
  display: block;
  border-radius: inherit;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.border {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  border: var-default(--avatar-border-width) solid transparent;
  mask:
    linear-gradient(white 0 0) padding-box,
    linear-gradient(white 0 0);
  mask-composite: exclude;
}

.sticker {
  position: absolute;
  top: var-default(--avatar-sticker-top);
  right: var-default(--avatar-sticker-right);
  width: var-default(--avatar-sticker-height);
  height: var-default(--avatar-sticker-height);
}
</style>
